module.exports = __webpack_public_path__ + "img/19.5ecb304b.png";